<template>
  <div id="device-bg-main">
    <check-in-check-out-page />
  </div>
</template>

  <script>
  import CheckInCheckOutPage from '../components/CheckInCheckOutPage.vue';
    export default {
      name: 'Home',
      components: {
        CheckInCheckOutPage,
      },
    };
  </script>
